export default __webpack_public_path__ + "static/lua-baeaf6fb961504f5dd46b4d32c119d05.jpg";